const getWeekOrders = (ordersState) => ordersState.byWeek;
const getWeekOrdersByUser = (ordersState) => ordersState.byUserWeek;
const getUserOrdersIdsBeforeSync = (ordersState) => ordersState.userOrdersIdsBeforeSync;

export default {
  getWeekOrders,
  getWeekOrdersByUser,
  getUserOrdersIdsBeforeSync,
};



// WEBPACK FOOTER //
// ./store/modules/orders/getters.js